export default __webpack_public_path__ + "static/media/logo.d8c5b437.png";